import { useCallback, useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Collapse } from "bootstrap";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const collapseRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const element = collapseRef.current;
    if (!element) return undefined;

    const handleShown = () => setMenuOpen(true);
    const handleHidden = () => setMenuOpen(false);

    element.addEventListener("shown.bs.collapse", handleShown);
    element.addEventListener("hidden.bs.collapse", handleHidden);

    return () => {
      element.removeEventListener("shown.bs.collapse", handleShown);
      element.removeEventListener("hidden.bs.collapse", handleHidden);
      Collapse.getInstance(element)?.dispose();
    };
  }, []);

  const getCollapse = useCallback(() => {
    if (!collapseRef.current) return null;
    return Collapse.getOrCreateInstance(collapseRef.current, { toggle: false });
  }, []);

  const toggleNavbar = () => {
    if (window.innerWidth >= 992) return;
    getCollapse()?.toggle();
  };

  const closeNavbar = () => {
    if (window.innerWidth >= 992) return;
    getCollapse()?.hide();
  };

  return (
    <header className={`main-header ${sticky ? "sticky" : ""}`}>
      <div className="navbar-area bg-light shadow">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <Link className="navbar-brand" to="/" onClick={closeNavbar}>
              <img
                src="/assets/images/favicon.jpeg"
                alt="Logo"
                style={{ width: "60px" }}
                loading="eager"
                fetchPriority="high"
              />
            </Link>

            <button
              className={`navbar-toggler ${menuOpen ? "" : "collapsed"}`}
              type="button"
              onClick={toggleNavbar}
              aria-controls="navbarSupportedContent"
              aria-expanded={menuOpen}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
              ref={collapseRef}
            >
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                {navItems.map(({ to, label, end }) => (
                  <li key={to} className="nav-item">
                    <NavLink
                      to={to}
                      end={end}
                      className={({ isActive }) =>
                        `nav-link${isActive ? " active" : ""}`
                      }
                      onClick={closeNavbar}
                    >
                      {({ isActive }) => (
                        <span
                          className={`fw-bold ${
                            isActive ? "text-danger" : "text-dark"
                          }`}
                        >
                          {label}
                        </span>
                      )}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
